import type { Action } from 'components/Layout/PaymentViewLayout';
import type { InvoiceStatus } from 'payments-api/model';
import { PaymentViewLayout } from 'components/Layout/PaymentViewLayout';
import React from 'react';

import {
  LayoutCell,
  LayoutRow,
  TextCell,
} from '@fragment/ui/src/components/Payments/LayoutRow';
import { StatusBadge } from '@fragment/ui/src/components/Payments/StatusBadge';
import { TabsV2 } from '@fragment/ui/src/components/Tabs/TabsV2';

type Props = {
  onBack: () => void;
  title: string;
  primaryAction?: Action;
  secondaryAction?: Action;
  status: InvoiceStatus;
  issued: string;
  setTitle?: (title: string) => void;
  children: React.ReactNode;
  users: string[];
  selectedUserId: string;
  setSelectedUserId: (userId: string) => void;
};

export const InvoiceLayout = ({
  onBack,
  title,
  primaryAction,
  secondaryAction,
  status,
  issued,
  setTitle,
  selectedUserId,
  setSelectedUserId,
  children,
  users,
}: Props) => (
  <PaymentViewLayout
    title={title}
    onBack={onBack}
    primaryAction={primaryAction}
    secondaryAction={secondaryAction}
  >
    {/* start title section */}
    <LayoutRow height="large">
      <TextCell
        text={title}
        textSize="lg"
        align="left"
        border="none"
        onChange={setTitle ? (text) => setTitle(text) : undefined}
        fullWidth
        data-testid="invoice-title-input"
      />
      <LayoutCell border="left">
        <StatusBadge status={status as 'draft' | 'closed' | 'open'} />
      </LayoutCell>
    </LayoutRow>

    {/* start detail section */}
    <LayoutRow height="small" justify="start">
      <TextCell
        text="Issued"
        textSize="md"
        align="left"
        border="right"
        textType="secondary"
      />
      <TextCell
        text={new Date(issued).toDateString().split(' ').slice(1).join(' ')}
        textSize="md"
        align="left"
        border="none"
        useMonoText
      />
    </LayoutRow>
    <LayoutRow height="fit" justify="start">
      <TextCell
        text="View Invoice As"
        textSize="md"
        align="left"
        border="right"
        textType="secondary"
      />
      <TabsV2
        options={[
          { label: 'All', value: 'all' },
          ...users.map((userId) => ({ label: userId, value: userId })),
        ]}
        selectedValue={selectedUserId}
        onClick={setSelectedUserId}
      />
    </LayoutRow>
    {children}
  </PaymentViewLayout>
);
